/*eslint-disable*/
import {
  FETCH_FB_MESSAGES_FAILURE,
  FETCH_FB_MESSAGES_REQUEST,
  FETCH_FB_MESSAGES_SUCCESS,
  RESET_FB_MESSAGES,
} from './actionCreator';

const initialState = {
  messages: [],
  paging: null,
  pageId: null,
  loading: false,
  isFetchingMore: false,
  error: null,
};

const facebookMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FB_MESSAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_FB_MESSAGES_SUCCESS: {
      const { data, paging, pageId, isLoadMore } = action.payload;

      const mergedMessages = isLoadMore
        ? [...state.messages, ...data]
        : state.messages.length > 0
        ? state.messages 
        : data;

      return {
        ...state,
        loading: false,
        messages: mergedMessages,
        paging,
        pageId,
        error: null,
      };
    }

    case FETCH_FB_MESSAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case RESET_FB_MESSAGES:
      return initialState;

    default:
      return state;
  }
};

export default facebookMessageReducer;
